import { render, staticRenderFns } from "./BusinessLogisticsView.vue?vue&type=template&id=488ee922&scoped=true&"
import script from "./BusinessLogisticsView.vue?vue&type=script&lang=ts&"
export * from "./BusinessLogisticsView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessLogisticsView.vue?vue&type=style&index=0&id=488ee922&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ee922",
  null
  
)

export default component.exports